import { BsFileEarmarkPdfFill } from "react-icons/bs";

const PdfIcon = BsFileEarmarkPdfFill as React.FC<{
  size?: number;
  color?: string;
}>;

export default PdfIcon;

// Usage
{
  /* <PdfIcon size={24} color="#8B0000" />; */
}
